import StorefrontIcon from '@mui/icons-material/Storefront';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import BugReportIcon from '@mui/icons-material/BugReport';
import Inventory2Icon from '@mui/icons-material/Inventory2';

export const warehouseWebshopCredentialsDataConfig = (dataTotals) => {
    return {
        orders:  {
            title: 'orders',
            icon: <StorefrontIcon/>,
            isSingleDataGrid: true,
          //  ...(dataTotals && {count: dataTotals.orders})
        },
        orderlogs:  {
            title: 'order_import',
            icon: <AssignmentReturnIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.importOrderFailedCount})
        },
        returns:  {
            title: 'returns',
            icon: <AssignmentReturnIcon/>,
            isSingleDataGrid: true,
         //   ...(dataTotals && {count: dataTotals.returns})
        },
        products:  {
            title: 'products',
            icon: <Inventory2Icon/>,
            isSingleDataGrid: true,
         //   ...(dataTotals && {count: dataTotals.products})
        }
    };
}; 